import { get, post } from "./index";
export enum Status {
  Completed = "completed",
  Pending = "pending",
  Timeout = "timeout",
}

export enum OrderType {
  Normal = "normal",
  DirectPay = "directPay",
  Withdraw = "withdraw",
}

export interface Order {
  orderAmount: string;
  spendAmount: string;
  taxAmount: string;
  taxRate: string;
  tipAmount: string;
  id: number;
  status: Status;
  hash: string;
  orderType?: string;
  createdAt: string;
  updatedAt: string;
  recipientAmount: string;
  spentCurrency: string;
  spentAmount: string;
  feeAmount: string;
  recipient: {
    didName: string;
    address: string;
    avatar: string;
  };
  sender: {
    didName: string;
    address: string;
    avatar: string;
  };
}

export interface OrderDetail extends Order {
  displayAmount: string;
}

export const createOrder = async (data: {
  orderAmount: string;
  taxRate: string;
}) => {
  const response = await post<Order>("/orders", data);
  return response;
};

export const getOrder = async (orderId: string) => {
  const response = await get<Order>(`/orders/${orderId}`);
  return response;
};

export const getOrdersByRecipient = async ({
  recipient,
  status,
  orderType,
}: {
  recipient: string;
  status: Status;
  orderType?: OrderType;
}) => {
  let url = `/orders?recipient=${recipient}&status=${status}&isMerchant=${true}`;
  if (orderType) {
    url += `&orderType=${orderType}`;
  }
  const response = await get<Order[]>(url);
  return response;
};

export const createWithdrawOrder = async (data: {
  spendAmount: string;
  recipientAmount: string;
  opUserHash: string;
  recipient: string;
  sender: string;
}) => {
  const response = await post<Order>("/orders/withdraw", data);
  return response;
};
